module.exports = __webpack_public_path__ + "static/media/university.d44c30d6.png";